export default __webpack_public_path__ + "static/media/broken-logo.41e40285.svg";